export const optionalFunc = <TArgs, TResult>(func: (args?: TArgs) => TResult, args: TArgs) =>
  func ? func(args) : undefined;
